(() => {
    const JustifiedGrid = function ({element, targetHeight, gap, justify, fillerBg}) {
        this.container = element;
        this.images = Array.prototype.slice.call(this.container.querySelectorAll("img"), 0);
        this.targetHeight = targetHeight || 300;
        this.gap = gap || 2;

        this.filler = document.createElement('DIV');
        this.filler.style.background = fillerBg || 'grey';

        this.container.append(this.filler);

        let imagesLoadedNumber = 0;
        const imagesNumber = this.images.length;
        const obj = this;
        const onLoadImage = function () {
            imagesLoadedNumber++;
            if (imagesNumber === imagesLoadedNumber) {
                obj.setGrid.call(obj);
                setTimeout(() => {
                    obj.container.classList.add("initialized");
                }, 100);
                let timeout = 0;
                window.addEventListener("resize", () => {
                    clearTimeout(timeout);
                    timeout = setTimeout(() => {
                        obj.setGrid.call(obj);
                    }, 300);
                })
            }
        };
        this.images.forEach((img) => {
            img.complete && img.naturalHeight > 0
                ? onLoadImage()
                : img.addEventListener("load", onLoadImage);
        });
        this.container.style.fontSize = "0";
        this.container.style.lineHeight = "0";
        this.container.style.textAlign = justify || 'center';
        this.container.style.overflow = "hidden";
    };

    const fn = JustifiedGrid.prototype;
    fn.setGrid = function () {
        const obj = this;
        const rows = [{
            ratio: 0,
            images: []
        }];
        obj.images.forEach(function (image, index) {
            const rowRatio = (obj.container.offsetWidth - Math.max(0, rows[rows.length - 1].images.length - 1) * obj.gap) / obj.targetHeight;
            if (rows[rows.length - 1].ratio > rowRatio) {
                rows.push({
                    ratio: 0,
                    images: []
                });
            }
            rows[rows.length - 1].images.push(index);
            rows[rows.length - 1].ratio += image.naturalWidth / image.naturalHeight;
        });

        const pxToSize = (px) => ((px / obj.container.offsetWidth) * 100) + '%';

        rows.forEach(function (row, index) {
            const multiplier = row.ratio / ((obj.container.offsetWidth - (row.images.length - 1) * obj.gap) / obj.targetHeight);
            const marginTop = pxToSize(index > 0 ? obj.gap : 0);

            row.images.forEach((imageIndex, i) => {
                const image = obj.images[imageIndex];
                const height = obj.targetHeight / Math.max(1, multiplier);
                image.style.width = pxToSize(height * (image.naturalWidth / image.naturalHeight));
                image.style.marginLeft = pxToSize(i > 0 ? obj.gap : 0);
                image.style.marginTop = marginTop;
            });
            /*
            var width = ((obj.container.offsetWidth - row.images.length * obj.gap) / obj.targetHeight - row.ratio) * obj.targetHeight;
            obj.filler.style.width = pxToSize(width);
            obj.filler.style.height = 0;
            obj.filler.style.position = 'absolute';
            obj.filler.style.paddingBottom = (obj.targetHeight / obj.container.offsetWidth  * 100) + '%';
            obj.filler.style.marginLeft = pxToSize(obj.gap);
            obj.filler.style.marginTop = marginTop;
            obj.filler.style.visibility = multiplier < 1 ? 'visible' : 'hidden';
            */
        });
    };

    window.addEventListener("load", function () {
        document.querySelectorAll('[data-justified-grid]').forEach((element) => {
            new JustifiedGrid({
                element,
                targetHeight: parseInt(element.getAttribute('data-justified-grid')) | 300,
                gap: parseInt(element.getAttribute('data-justified-grid-gap')) | 2,
                justify: element.getAttribute('data-justified-grid-justify') | 'center',
                fillerBg: element.getAttribute('data-justified-grid-filler-bg') | 'transparent',
            });
        });
    });
})();
